import { TextPreviewModal } from "Components/previewModal";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import TextArea from "devextreme-react/text-area";
import { Button as TextBoxButton } from "devextreme-react/text-box";
import head from "lodash/head";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import locale from "./textAreaWidget.locale";
const isLargeText = (textarea) => Boolean(textarea && !textarea.classList.contains("dx-texteditor-input-auto-resize"));
function TextAreaWidget({ className, value, onChange, placeholder, height, minHeight, maxHeight, autoResizeEnabled, defaultSingleLine, valueChangeEvent, textAreaRef, maxLength, disabled, readOnly, usePreviewButton, previewTitle, fieldName, label, labelMode, ...other }) {
    const initialRef = useRef(null);
    const ref = textAreaRef || initialRef;
    const textareaRef = useRef();
    const [needPreviewButton, setNeedPreviewButton] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    useEffect(() => {
        var _a;
        textareaRef.current = head((_a = ref.current) === null || _a === void 0 ? void 0 : _a.instance.element().getElementsByTagName("textarea"));
    }, []);
    useEffect(() => {
        if (usePreviewButton)
            setNeedPreviewButton(isLargeText(textareaRef.current));
    }, [value]);
    const handleChange = useCallback((e) => {
        e.event && onChange && onChange(e.value, fieldName);
    }, [onChange, fieldName]);
    const showPreviewOptions = useMemo(() => ({
        icon: "icon-glass-plus text-gray-500",
        elementAttr: {
            class: "no-border bg-transparent animate-hover-color p-0",
            style: { position: "absolute", bottom: 2, right: 18 },
            hint: locale.SHOW_PREVIEW
        },
        disabled: false,
        onClick: () => {
            setShowPreview(true);
        },
        width: 20,
        height: 20
    }), []);
    const handleHidePreview = useCallback(() => {
        setShowPreview(false);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(TextArea, { className: classNames("w-100", className), placeholder: placeholder, onValueChanged: handleChange, value: value !== null && value !== void 0 ? value : "", valueChangeEvent: valueChangeEvent, mode: "text", height: autoResizeEnabled ? undefined : height, minHeight: defaultSingleLine ? parseInt(themeVariables["input-height-base"]) : minHeight, maxHeight: maxHeight, spellcheck: false, autoResizeEnabled: autoResizeEnabled, ref: ref, maxLength: maxLength, readOnly: readOnly, disabled: disabled, labelMode: labelMode, label: label, ...other }, usePreviewButton && needPreviewButton && (React.createElement(TextBoxButton, { name: "show-preview-button", location: "after", options: showPreviewOptions }))),
        usePreviewButton && needPreviewButton && value && (React.createElement(TextPreviewModal, { text: value, show: showPreview, onHide: handleHidePreview, title: previewTitle }))));
}
export default memo(TextAreaWidget);
TextAreaWidget.defaultProps = {
    placeholder: "",
    minHeight: 74,
    maxLength: 2000,
    autoResizeEnabled: true,
    defaultSingleLine: false,
    valueChangeEvent: "input"
};
